<template>
  <v-container fluid fill-height pa-0>
    <v-layout fill-height ma-0 pt-1>
      <v-flex xs2>
        <manage-tree
          :template="template"
        />
      </v-flex>
      <v-layout column  ma-0>
        <v-flex xs12 v-if="componentShow" ref="manage_bar_wrapper"  style="border: solid 1px #b3d4fc; border-radius: 5px; position: relative;">
          <uni-configuration
            v-if="getActiveTree == 'VLAN_configuration'"
            :data="getData"
            :treeActive="$store.state.structure.manage.treeActive"
          />
          <port-membership
            v-if="getActiveTree == 'VLAN_port_membership'"
            :data="getData"
          />

          <fmc
            v-if="getActiveTree == 'maintenance_file_management_configuration'"
            :data="getData"
          />

          <uni-descr-component
            v-if="
              getActiveTree != 'VLAN_configuration' &&
              getActiveTree != 'VLAN_port_membership' &&
              getActiveTree != 'maintenance_file_management_configuration'
            "
            :data="getData"
            @update="(payload) => {$emit('update', payload)}"
          />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import ManageTree from '@/nms/components/device-configuration/manage/manage-tree.vue'
import UniDescrComponent from '@/nms/components/device-configuration/manage/page/component.vue'
import UniConfiguration from '@/nms/components/device-configuration/manage/page/switching/vlan/configuration.vue'
import PortMembership from '@/nms/components/device-configuration/manage/page/switching/vlan/port-membership.vue'
import fmc from '@/nms/pages/configuration/fill-management/fill_management_configuration.vue'

// Типы
interface DeviceData {
  [key: string]: any
}

interface TemplateData {
  [key: string]: any
}

interface ManageState {
  treeActive?: Array<{ id?: string; [key: string]: any }>
}

interface StructureState {
  manage: ManageState
}

export default Vue.extend({
  name: 'MANAGE_DEVICE',

  components: {
    ManageTree,
    UniDescrComponent,
    UniConfiguration,
    PortMembership,
    fmc,
  },

  props: {
    data: {
      type: Object as () => DeviceData,
      default: () => ({})
    },
    template: {
      type: Object as () => TemplateData,
      default: () => ({})
    },
  },

  data(): {
    testTableBarOpen: boolean
    manage_bar_size: number
    componentShow: boolean
  } {
    return {
      testTableBarOpen: false,
      manage_bar_size: 1000,
      componentShow: true,
    }
  },

  computed: {
    getData(): DeviceData {
      return this.data
    },

    getActiveTree(): string | undefined {
      const structure = this.$store.state.structure as StructureState
      return structure.manage.treeActive?.[0]?.id
    },
  },

  watch: {
    data: {
      handler(newVal: DeviceData): void {
        this.componentShow = false
        this.setup()
        this.$nextTick(() => {
          this.componentShow = true
        })
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    const wrapper = this.$refs['manage_bar_wrapper'] as HTMLElement
    if (wrapper) {
      this.manage_bar_size = wrapper.clientWidth
    }
  },

  methods: {
    setup(): void {
      console.log(this.$options.name, 'DATA', this.data)
      console.log(this.$options.name, 'TEMPLATE', this.template)
    },
  },
})
</script>

<style lang="css" scoped>
</style>
